import React from 'react';
import SelectInput from '@/common/components/SelectInput';
import { TopContentWrapper } from '../shared.styles';
import {
	PRODUCT_SELECT_MAX_HEIGHT,
	PRODUCT_STATUS_OPTIONS,
} from '../../constants/productStatusOptions';

const ProductChartFilters = ({
	productStatus,
	setProductStatus,
	productOptions,
	selectedProducts,
	setSelectedProducts,
}) => (
	<TopContentWrapper>
		<SelectInput
			name='Status'
			options={PRODUCT_STATUS_OPTIONS}
			selected={productStatus}
			setSelected={setProductStatus}
			selectWidth={140}
			width={70}
			gap='10px'
			margin='0'
			fontSize={14}
		/>
		<SelectInput
			name='Products'
			options={productOptions}
			selected={selectedProducts}
			setSelected={(value) => setSelectedProducts(value || [])}
			selectWidth={360}
			width={90}
			gap='10px'
			margin='0'
			fontSize={14}
			multiple
			maxHeight={PRODUCT_SELECT_MAX_HEIGHT}
		/>
	</TopContentWrapper>
);

export default ProductChartFilters;
